'use client';

import { InnerContent } from '@/components/atoms/InnerContent/InnerContent';
import { buildSummaryItem } from './styled';

interface SummaryProps {
  summaryItems: { [key: string]: any };
  careType: string;
  isColumn?: boolean;
  isSmall?: boolean;
}
export const Summary = ({
  summaryItems,
  careType,
  isSmall,
  isColumn,
}: SummaryProps) => {
  const items = Object.entries(summaryItems)
    .map(([key, item]) => {
      return buildSummaryItem({ summaryItem: [key, item], careType });
    })
    .filter((item) => item && item?.show !== false);

  return (
    <InnerContent
      size='sm'
      maxColumns={isSmall || isColumn ? 1 : 2}
      items={items.map((item) => ({
        ...item,
        title: item.label,
        description: item.description,
        iconSize: item.iconSize || '1x',
        iconColor: item.color as any,
      }))}
    />
  );
};

export default Summary;
